var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { hasMany, belongsTo, attr } from '@ember-data/model';
import { sortBy, uniqueValues } from 'ilios-common/utils/array-helpers';
import { cached } from '@glimmer/tracking';
import { TrackedAsyncData } from 'ember-async-data';
let SessionObjectiveModel = (_dec = attr('string'), _dec2 = attr('number', {
  defaultValue: 0
}), _dec3 = attr('boolean', {
  defaultValue: true
}), _dec4 = belongsTo('session', {
  async: true,
  inverse: 'sessionObjectives'
}), _dec5 = hasMany('term', {
  async: true,
  inverse: 'sessionObjectives'
}), _dec6 = hasMany('mesh-descriptor', {
  async: true,
  inverse: 'sessionObjectives'
}), _dec7 = belongsTo('session-objective', {
  inverse: 'descendants',
  async: true
}), _dec8 = hasMany('session-objective', {
  inverse: 'ancestor',
  async: true
}), _dec9 = hasMany('course-objective', {
  inverse: 'sessionObjectives',
  async: true
}), _class = class SessionObjectiveModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "title", _descriptor, this);
    _initializerDefineProperty(this, "position", _descriptor2, this);
    _initializerDefineProperty(this, "active", _descriptor3, this);
    _initializerDefineProperty(this, "session", _descriptor4, this);
    _initializerDefineProperty(this, "terms", _descriptor5, this);
    _initializerDefineProperty(this, "meshDescriptors", _descriptor6, this);
    _initializerDefineProperty(this, "ancestor", _descriptor7, this);
    _initializerDefineProperty(this, "descendants", _descriptor8, this);
    _initializerDefineProperty(this, "courseObjectives", _descriptor9, this);
  }
  get _termsData() {
    return new TrackedAsyncData(this.terms);
  }
  get _allTermVocabulariesData() {
    if (!this._termsData.isResolved) {
      return null;
    }
    return new TrackedAsyncData(Promise.all(this._termsData.value.map(t => t.vocabulary)));
  }
  get associatedVocabularies() {
    if (!this._allTermVocabulariesData?.isResolved) {
      return [];
    }
    return sortBy(uniqueValues(this._allTermVocabulariesData.value), 'title');
  }

  /**
   * @todo check if this method is obsolete, if so remove it [ST 2020/07/08]
   */
  get shortTitle() {
    return this.title?.substr(0, 200) ?? '';
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "title", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "position", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "active", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "session", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "terms", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "_termsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_termsData"), _class.prototype), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "meshDescriptors", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "ancestor", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "descendants", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "courseObjectives", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "_allTermVocabulariesData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_allTermVocabulariesData"), _class.prototype), _class);
export { SessionObjectiveModel as default };